import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'nl2br'
})
export class Nl2brPipe implements PipeTransform {
    transform(value: any) {
        if (!value) return null;

        value = value
            .toString()
            .replace(/\n/g, '<br />');

        return value;
    }
}